/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyLogoEntry
 */
export interface CompanyLogoEntry {
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoEntry
     */
    normalizedCompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoEntry
     */
    displayedCompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoEntry
     */
    logoUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyLogoEntry
     */
    fetchedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoEntry
     */
    sizeBytes?: number;
}

/**
 * Check if a given object implements the CompanyLogoEntry interface.
 */
export function instanceOfCompanyLogoEntry(value: object): value is CompanyLogoEntry {
    if (!('normalizedCompanyName' in value) || value['normalizedCompanyName'] === undefined) return false;
    if (!('displayedCompanyName' in value) || value['displayedCompanyName'] === undefined) return false;
    if (!('fetchedAt' in value) || value['fetchedAt'] === undefined) return false;
    return true;
}

export function CompanyLogoEntryFromJSON(json: any): CompanyLogoEntry {
    return CompanyLogoEntryFromJSONTyped(json, false);
}

export function CompanyLogoEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLogoEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'normalizedCompanyName': json['normalizedCompanyName'],
        'displayedCompanyName': json['displayedCompanyName'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'fetchedAt': (new Date(json['fetchedAt'])),
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
    };
}

export function CompanyLogoEntryToJSON(value?: CompanyLogoEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'normalizedCompanyName': value['normalizedCompanyName'],
        'displayedCompanyName': value['displayedCompanyName'],
        'logoUrl': value['logoUrl'],
        'fetchedAt': ((value['fetchedAt']).toISOString()),
        'sizeBytes': value['sizeBytes'],
    };
}

